import React from 'react';
import styles from './pageLoader.scss';

function Loader() {
    return (
        <div className="outerWrapper">
            <div className="wrapper">
                <div id="dot1"></div>
                <div id="dot2"></div>
                <div id="dot3"></div>
                <div id="dot4"></div>
                <div id="dot5"></div>
                <div id="dot6"></div>
                <div id="dot7"></div>
                <div id="dot8"></div>
                <div id="dot9"></div>
                <div id="dot10"></div>
                <div id="base1"></div>
                <div id="base2"></div>
                <div id="base3"></div>
                <div id="base4"></div>
                <div id="base5"></div>
            </div>
        </div>
    );
}

export default Loader;
